import { RootState } from "@/app/stores"
import { createUserInvitation, createUserInvitationsBulk, ICreateUserInvitation, ICreateUserInvitationResponse, IBulkUserInvitationResponse } from "@/shared/api/user-invitations"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchCreateUserInvitation = createAsyncThunk<
    ICreateUserInvitationResponse,
    ICreateUserInvitation,
    { state: RootState }
>('createUserInvitation/fetchCreate', async (data, thunkAPI) => {
    try {
        const { bot_id } = thunkAPI.getState().community.community
        const response = await createUserInvitation(bot_id, data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchCreateUserInvitationsBulk = createAsyncThunk<
    IBulkUserInvitationResponse,
    File,
    { state: RootState }
>('createUserInvitation/fetchBulk', async (file, thunkAPI) => {
    try {
        const { bot_id } = thunkAPI.getState().community.community
        const response = await createUserInvitationsBulk(bot_id, file)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
